import { useState, useEffect } from "react";
import { EmailCampaign, loadEmails } from "@/data/emailsStore";

export function useEmails() {
  const [emails, setEmails] = useState<EmailCampaign[]>([]);

  useEffect(() => {
    const fetchEmails = () => setEmails(loadEmails());
    fetchEmails(); // Initial load

    const handleStorageChange = () => fetchEmails();
    window.addEventListener("emailsChanged", handleStorageChange);
    
    return () => {
      window.removeEventListener("emailsChanged", handleStorageChange);
    };
  }, []);

  return { emails };
}
